module.exports = __webpack_public_path__ + "media/images/ohap__Arrow_White_Up-ab11e1e7060019f211806417331ab8c4.png";